import React, { useEffect } from 'react';
import './style.css';

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="section aboutPage pt-5 pb-5">
            <div className="container">
                <h1 className="hd mb-4">About Us</h1>
                <div className="content">
                    <p>Welcome to <strong>Paymond Services Private Limited</strong>, your ultimate destination for fashion and clothing online! At Paymond Services Private Limited, we're passionate about style, quality, and providing you with the latest trends at unbeatable prices.</p>

                    <p>Our journey began with a simple vision: to create an online shopping experience that's not just about products, but about creating moments of joy and self-expression through fashion. Founded by a team of fashion enthusiasts, we set out to curate a collection that reflects the diversity and dynamism of modern style.</p>

                    <p>What sets us apart is our commitment to offering a carefully curated selection of fashion-forward clothing and accessories that cater to every taste and occasion. From trendy streetwear to chic formal attire, we've got something for everyone, no matter your personal style or budget.</p>

                    <p>But we're more than just a fashion retailer – we're a community. We believe in the power of fashion to empower and inspire, and we're dedicated to creating a space where you can express yourself freely and confidently through your wardrobe choices.</p>

                    <p>At Paymond Services Private Limited, customer satisfaction is our top priority. That's why we go above and beyond to ensure that your shopping experience is seamless, from browsing our website to receiving your order at your doorstep. With fast shipping, easy returns, and dedicated customer support, we're here to make your shopping experience as enjoyable as possible.</p>

                    <p>Thank you for choosing Paymond Services Private Limited as your go-to destination for fashion and clothing online. Whether you're shopping for yourself or searching for the perfect gift, we're here to help you look and feel your best, every step of the way. Happy Shopping!</p>
                </div>
            </div>
        </section>
    );
}

export default About;